const i18n = {
  'en-US': {
    'register.form.title': 'Register new account',
    'register.form.subtitle': 'Register and start managing your supply chain',
    'register.form.identifier.errMsg': 'Account must be a phone or email',
    'register.form.verifyCode.errMsg': 'Verify code must be 6 digits',
    'register.form.getVerifyCode.errMsg': 'Get verify code error, please refresh and try again',
    'register.form.password.errMsg': 'Password cannot be empty',
    'register.form.register.errMsg': 'Register error, please refresh and try again',
    'register.form.identifier.placeholder': 'Please enter phone or email',
    'register.form.verifyCode.placeholder': 'Verify code',
    'register.form.getVerifyCode': 'Get verify code',
    'register.form.password.placeholder': 'Please enter password',
    'register.form.confirmPassword.placeholder': 'Please confirm password',
    'register.form.confirmPassword.errMsg': 'Passwords do not match',
    'register.form.login': 'Login',
    'register.form.register': 'Register account',
    'register.form.agreement.title': 'Agreement Confirmation',
    'register.form.agreement.confirm': 'Please confirm that you have read the',
    'register.form.agreement.and': ' and ',
    'register.form.agreement.okText': 'I have read',
    'register.form.agreement.cancelText': 'Cancel',
    'register.form.agreement.tip': 'By registering, you agree to the'
  },
  'zh-CN': {
    'register.form.title': '注册新账号',
    'register.form.subtitle': '开启智能、高效的供应链管理之路',
    'register.form.identifier.errMsg': '账号必须为手机号码或者邮箱地址',
    'register.form.verifyCode.errMsg': '验证码必须为6位数字',
    'register.form.getVerifyCode.errMsg': '获取验证码出错，请刷新重试',
    'register.form.password.errMsg': '密码不能为空',
    'register.form.register.errMsg': '注册出错，请刷新重试',
    'register.form.identifier.placeholder': '请输入手机号码或者邮箱地址',
    'register.form.verifyCode.placeholder': '请输入验证码',
    'register.form.getVerifyCode': '获取验证码',
    'register.form.password.placeholder': '请输入密码',
    'register.form.confirmPassword.placeholder': '请确认密码',
    'register.form.confirmPassword.errMsg': '两次输入密码不一致',
    'register.form.login': '登录',
    'register.form.register': '注册账号',
    'register.form.agreement.title': '协议确认',
    'register.form.agreement.confirm': '请确认您已阅读',
    'register.form.agreement.and': '和',
    'register.form.agreement.okText': '我已阅读',
    'register.form.agreement.cancelText': '取消',
    'register.form.agreement.tip': '注册即视为同意'
  }
};
export default i18n;